export default "__VITE_ASSET__DWyXdhxG__"